import { Collapse } from 'antd';
import styled from 'styled-components';

export const FAQContainer = styled(`section`)`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: calc(100vw - 32px);
		margin: 0 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		margin: 0 auto;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
	}
`;

export const FAQHeading = styled(`h1`)`
	margin: 40px 0 32px 0;
	font-weight: 600;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 24px;
		margin: 40px 0 24px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 24px;
		margin: 40px 0 24px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 30px;
		margin: 40px 0 32px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 30px;
		margin: 40px 0 32px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 30px;
		margin: 40px 0 32px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 30px;
		margin: 40px 0 32px 0;
	}
`;

export const QuestionsContainer = styled(Collapse)`
	margin-bottom: 40px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 100%;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 450px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 509px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 678px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 890px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 890px;
	}
`;

export const FAQSubheading = styled(`h3`)`
	font-weight: 600;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 16px;
		margin-bottom: 8px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
		margin-bottom: 8px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 20px;
		margin-bottom: 12px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 20px;
		margin-bottom: 12px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 20px;
		margin-bottom: 12px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 20px;
		margin-bottom: 12px;
	}
`;

export const FAQText = styled(`p`)`
	color: #262626;
	white-space: pre-wrap;
	font-weight: 400;

	line-height: 24px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
		margin: 0 0 26px 36px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}
`;

export const SupportTextStyled = styled(`p`)`
	margin: 0;
	color: #262626;
	font-weight: 400;
	line-height: 24px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
	}
`;

export const QuestionHeader = styled(`h3`)`
	margin: 0;
	color: #262626;
	font-weight: 600;
	line-height: 28px;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 16px;
		line-height: 24px;
		margin-left: 8px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
		line-height: 24px;
		margin-left: 8px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 20px;
		line-height: 28px;
		margin-left: 12px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 20px;
		line-height: 28px;
		margin-left: 12px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 20px;
		line-height: 28px;
		margin-left: 12px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 20px;
		line-height: 28px;
		margin-left: 12px;
	}
`;

export const FAQListStyled = styled(`ul`)`
	padding: 0;
	color: #262626;
	white-space: pre-wrap;
	font-weight: 400;
	line-height: 24px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
		margin: 0 0 26px 36px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
		margin: 0 60px 26px 60px;
	}
`;
